/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Cais_AuthorInputs */

const en_home_quotes_cais_author = /** @type {(inputs: Home_Quotes_Cais_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statement on AI Risk`)
};

/**
* | output |
* | --- |
* | "Statement on AI Risk" |
*
* @param {Home_Quotes_Cais_AuthorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_cais_author = /** @type {((inputs?: Home_Quotes_Cais_AuthorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Cais_AuthorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_cais_author(inputs)
});